
import React from 'react';

export default function ProjectTimeline() {
  const milestones = [
    {
      year: '2026年3月',
      title: '项目正式启动',
      description: '重庆市南岸区明明德志愿服务中心发起"点滴公益"，首批覆盖南岸区5个街道',
      icon: 'ri-flag-line',
    },
    {
      year: '2026年6月',
      title: '首个夏季行动',
      description: '启动"清凉一夏"专项行动，累计发放矿泉水50,000瓶',
      icon: 'ri-sun-line',
    },
    {
      year: '2026年9月',
      title: '99公益日',
      description: '参与腾讯99公益日，获得3,000+爱心网友支持，筹款突破10万元',
      icon: 'ri-heart-line',
    },
    {
      year: '2026年12月',
      title: '覆盖全市',
      description: '项目扩展至重庆市38个区县，建立完善的配送网络体系',
      icon: 'ri-map-pin-line',
    },
    {
      year: '2027年3月',
      title: '一周年庆典',
      description: '项目一周年，累计服务15,000+一线工作者，获得市级表彰',
      icon: 'ri-trophy-line',
    },
    {
      year: '2027年6月',
      title: '持续发展',
      description: '引入企业合作伙伴，建立长效机制，项目进入可持续发展阶段',
      icon: 'ri-rocket-line',
    },
  ];

  return (
    <section className="py-12 md:py-20 px-4 md:px-6 bg-[#F9F9F9]">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-8 md:mb-16">
          <h2 className="text-2xl md:text-4xl font-bold text-[#1E1E1E] mb-3 md:mb-4">
            项目发展历程
          </h2>
          <p className="text-sm md:text-lg text-[#6C6C6C]">
            从起步到成长，每一步都凝聚着爱心与坚持
          </p>
        </div>

        <div className="relative">
          {/* Timeline Line - 居中垂直线 */}
          <div className="absolute left-1/2 -translate-x-1/2 w-1 h-full bg-[#E0E0E0] z-0" />

          {/* Timeline Items - 更紧凑的间距 */}
          <div className="space-y-0">
            {milestones.map((milestone, index) => (
              <div
                key={index}
                className={`relative flex items-start ${
                  index % 2 === 0
                    ? 'min-h-[100px] md:min-h-[120px]'
                    : 'min-h-[100px] md:min-h-[120px] -mt-12 md:-mt-16'
                }`}
              >
                {/* Center Dot - 放在卡片后面 */}
                <div
                  className={`absolute left-1/2 -translate-x-1/2 w-3 h-3 md:w-5 md:h-5 bg-[#2A7A62] rounded-full border-2 md:border-4 border-white shadow-lg z-0 top-6 md:top-8`}
                />

                {/* 左右交替内容 */}
                <div
                  className={`w-full flex ${
                    index % 2 === 0 ? 'justify-start' : 'justify-end'
                  }`}
                >
                  <div
                    className={`w-[calc(50%-16px)] md:w-[calc(50%-28px)] ${
                      index % 2 === 0 ? 'pr-1 md:pr-3' : 'pl-1 md:pl-3'
                    }`}
                  >
                    <div className="bg-white rounded-lg md:rounded-xl shadow-md md:shadow-lg p-3 md:p-5 hover:shadow-xl transition-shadow duration-300 relative z-10">
                      {/* 上面图标，下面文字的布局 */}
                      <div className="flex flex-col items-center text-center">
                        <div className="w-10 h-10 md:w-14 md:h-14 bg-[#2A7A62] rounded-full flex items-center justify-center mb-2 md:mb-3">
                          <i
                            className={`${milestone.icon} text-base md:text-2xl text-white`}
                          />
                        </div>
                        <div className="text-[#F4B942] font-bold text-xs md:text-sm mb-1">
                          {milestone.year}
                        </div>
                        <h3 className="text-xs md:text-base font-bold text-[#1E1E1E] mb-1 md:mb-2">
                          {milestone.title}
                        </h3>
                        <p className="text-[9px] md:text-sm text-[#6C6C6C] leading-relaxed line-clamp-3">
                          {milestone.description}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
